import { onUnmounted, watch, type Ref } from 'vue'

export function usePwaDisplayClass(isInstalled: Ref<boolean>): void {
  const applyClass = (installed: boolean) => {
    document.documentElement.classList.toggle('pwa-installed', installed)
  }

  applyClass(isInstalled.value)
  watch(isInstalled, applyClass)

  onUnmounted(() => applyClass(false))
}
